export default __webpack_public_path__ + "media/logos/black_2x-d1323af4.png";